import React from 'react';
import { Scale } from 'lucide-react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
}

const sizeMap = {
  sm: { container: 'h-8 w-8', icon: 'h-4 w-4' },
  md: { container: 'h-12 w-12', icon: 'h-6 w-6' },
  lg: { container: 'h-16 w-16', icon: 'h-8 w-8' },
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  message,
}) => {
  const s = sizeMap[size];

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div className={`${s.container} relative flex items-center justify-center`}>
        <div className="absolute inset-0 rounded-full border-2 border-legal-green-400/20 animate-ping" />
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-gold-400 animate-spin" />
        <Scale className={`${s.icon} text-legal-green-500`} />
      </div>
      {message && (
        <p className="mt-4 text-text-secondary text-sm">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
